import styles from './empty-state.module.sass';

const Icon = () => {
  return (
    <svg
      width="60"
      height="60"
      minWidth="60"
      viewBox="0 0 24 24"
      fill="none"
      color="#999999"
      className={styles.icon}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 17C20.5 17.2761 20.2761 17.5 20 17.5L4 17.5C3.72386 17.5 3.5 17.2761 3.5 17L3.5 7C3.5 6.72386 3.72386 6.5 4 6.5L20 6.5C20.2761 6.5 20.5 6.72386 20.5 7V8.91477C19.0118 9.15406 17.8749 10.4443 17.8749 12C17.8749 13.5557 19.0118 14.8459 20.5 15.0852V17Z"
        stroke="#333333"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.7487 8.91142L12.4661 10.4302C12.485 10.4707 12.5132 10.5056 12.5483 10.5318C12.5834 10.558 12.6242 10.5746 12.667 10.5801L14.2645 10.8299C14.3148 10.8363 14.3624 10.8574 14.4016 10.8909C14.4409 10.9244 14.4702 10.9689 14.4863 11.0191C14.5023 11.0693 14.5043 11.1233 14.4922 11.1747C14.48 11.2261 14.4542 11.2728 14.4176 11.3095L13.2601 12.4885C13.228 12.522 13.2042 12.5632 13.1909 12.6085C13.1775 12.6538 13.175 12.7018 13.1836 12.7483L13.461 14.407C13.4706 14.4605 13.4655 14.5157 13.4464 14.5664C13.4274 14.617 13.395 14.661 13.3531 14.6934C13.3111 14.7257 13.2613 14.745 13.2094 14.7492C13.1574 14.7533 13.1054 14.7421 13.0592 14.7167L11.6244 13.9274C11.5856 13.9079 11.5431 13.8977 11.5 13.8977C11.4569 13.8977 11.4144 13.9079 11.3756 13.9274L9.94077 14.7167C9.89464 14.7421 9.84261 14.7533 9.79064 14.7492C9.73868 14.745 9.68887 14.7257 9.64694 14.6934C9.60501 14.661 9.57265 14.617 9.55356 14.5664C9.53446 14.5157 9.52942 14.4605 9.539 14.407L9.81642 12.7483C9.82497 12.7018 9.82246 12.6538 9.80912 12.6085C9.79578 12.5632 9.77201 12.522 9.73989 12.4885L8.58242 11.3095C8.54584 11.2728 8.51997 11.2261 8.50782 11.1747C8.49566 11.1233 8.49772 11.0693 8.51374 11.0191C8.52977 10.9689 8.55912 10.9244 8.59837 10.8909C8.63762 10.8574 8.68516 10.8363 8.73548 10.8299L10.333 10.5801C10.3758 10.5746 10.4166 10.558 10.4517 10.5318C10.4868 10.5056 10.515 10.4707 10.5339 10.4302L11.2513 8.91142C11.2742 8.86297 11.3096 8.82217 11.3536 8.79364C11.3975 8.76512 11.4483 8.75 11.5 8.75C11.5517 8.75 11.6025 8.76512 11.6464 8.79364C11.6904 8.82217 11.7258 8.86297 11.7487 8.91142Z"
        fill="#333333"
      />
    </svg>
  );
};

export const EmptyState = ({ content }) => {
  return (
    <div className={styles.root}>
      <Icon />
      {content}
    </div>
  );
};
